import React, { forwardRef } from 'react'

import { IconProps } from './types'

const EyeCross = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.61328 6.61328C6.19807 6.97975 6 7.40265 6 8C6 9.10457 6.89543 10 8 10C8.59735 10 9.02025 9.80193 9.38672 9.38672M6 3.30485C6.6016 3.11186 7.26724 3 8 3C12 3 14 6.33333 14.5 8C14.2985 8.67172 13.8533 9.61416 13.1318 10.5M2 2L14 14M4 4.37876C2.59167 5.49242 1.79129 7.02904 1.5 8C2 9.66667 4 13 8 13C9.4068 13 10.5662 12.5877 11.5 11.9806"
        stroke={color}
      />
    </svg>
  ),
)

EyeCross.displayName = 'EyeCross'

EyeCross.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default EyeCross
